package com.wintermar.inspection.feature.domain.model.auth

data class LoginModel(
    val token: String = "",
    val refreshToken: String = "",
    val failedAttemptMessage: String = "",
    val user: UserModel = UserModel()
)
